/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    compact: { type: 'variant', values: [ true ] },
    mini: { type: 'variant', values: [ true ] }
  },
  rules: [
    { if: { compact: true }, tokens: {} },
    {
      if: { mini: true },
      tokens: {
        borderColor: 'rgba(0, 0, 0, 0)',
        contentPaddingBottom: 0,
        contentPaddingLeft: 0,
        contentPaddingRight: 0,
        contentPaddingTop: 0,
        contentPanelBackgroundColor: 'rgba(0, 0, 0, 0)',
        contentPanelPaddingBottom: 0,
        contentPanelPaddingTop: 0,
        marginBottom: 0
      }
    }
  ],
  tokens: {
    borderColor: '#efefef',
    borderRadius: 4,
    borderWidth: 1,
    collapseDuration: 250,
    contentPaddingBottom: 16,
    contentPaddingLeft: 16,
    contentPaddingRight: 16,
    contentPaddingTop: 16,
    contentPanelBackgroundColor: '#efefef',
    contentPanelBorderColor: 'rgba(0, 0, 0, 0)',
    contentPanelBorderWidth: 0,
    contentPanelFontColor: '#000000',
    contentPanelFontName: 'StagSans',
    contentPanelFontSize: 16,
    contentPanelFontWeight: '700',
    contentPanelLineHeight: 1.5,
    contentPanelPaddingBottom: 16,
    contentPanelPaddingLeft: 24,
    contentPanelPaddingRight: 24,
    contentPanelPaddingTop: 16,
    expandDividerColor: null,
    expandDividerWidth: null,
    expandDuration: 300,
    marginBottom: 8
  }
}
export default theme
